import { render, staticRenderFns } from "./termsService.vue?vue&type=template&id=4bb7fab8&scoped=true&"
import script from "./termsService.vue?vue&type=script&lang=js&"
export * from "./termsService.vue?vue&type=script&lang=js&"
import style0 from "./termsService.vue?vue&type=style&index=0&id=4bb7fab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb7fab8",
  null
  
)

export default component.exports